import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingStateService {
  public loadingStates = signal<{ [key: string]: boolean }>({});

  getLoadingState(id: string): boolean {
    return this.loadingStates()[id] || false;
  }

  setLoading(id: string, state: boolean): void {
    this.loadingStates.update((current) => ({
      ...current,
      [id]: state,
    }));
  }
}
